var map = {
	"./Alabama.json": 1051,
	"./Alaska.json": 1052,
	"./Arizona.json": 1053,
	"./Arkansas.json": 1054,
	"./California.json": 1055,
	"./Colorado.json": 1056,
	"./Connecticut.json": 1057,
	"./Delaware.json": 1058,
	"./District of Columbia.json": 1059,
	"./Florida.json": 1060,
	"./Georgia.json": 1061,
	"./Hawaii.json": 1062,
	"./Idaho.json": 1063,
	"./Illinois.json": 1064,
	"./Indiana.json": 1065,
	"./Iowa.json": 1066,
	"./Kansas.json": 1067,
	"./Kentucky.json": 1068,
	"./Louisiana.json": 1069,
	"./Maine.json": 1070,
	"./Maryland.json": 1071,
	"./Massachusetts.json": 1072,
	"./Michigan.json": 1073,
	"./Minnesota.json": 1074,
	"./Mississippi.json": 1075,
	"./Missouri.json": 1076,
	"./Montana.json": 1077,
	"./Nebraska.json": 1078,
	"./Nevada.json": 1079,
	"./New Hampshire.json": 1080,
	"./New Jersey.json": 1081,
	"./New Mexico.json": 1082,
	"./New York.json": 1083,
	"./North Carolina.json": 1084,
	"./North Dakota.json": 1085,
	"./Ohio.json": 1086,
	"./Oklahoma.json": 1087,
	"./Oregon.json": 1088,
	"./Pennsylvania.json": 1089,
	"./Rhode Island.json": 1090,
	"./South Carolina.json": 1091,
	"./South Dakota.json": 1092,
	"./Tennessee.json": 1093,
	"./Texas.json": 1094,
	"./Utah.json": 1095,
	"./Vermont.json": 1096,
	"./Virginia.json": 1097,
	"./Washington.json": 1098,
	"./West Virginia.json": 1099,
	"./Wisconsin.json": 1100,
	"./Wyoming.json": 1101
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1407;



//////////////////
// WEBPACK FOOTER
// ./src/data/impact ^\.\/.*\.json$
// module id = 1407
// module chunks = 184088790168614